import { defineStore } from 'pinia'

import { IFileUpload } from '@shared/models/proto/base/file-upload'
import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'

import { DocumentCreateDTO } from '@pc/models/proto/dto/pdfs'
import { DocumentItemRO } from '@pc/models/proto/ro/pdfs'

export const apiTransport = new ApiTransport(resourcePath, 'pc')

export const usePdfsStore = defineStore({
  id: 'pdfs',

  actions: {
    async createPdf(params?: { files: IFileUpload[]; conversationId: number }) {
      const response = (await apiTransport.post<
        DocumentCreateDTO,
        DocumentItemRO
      >(
        `/pdfs`,
        new DocumentCreateDTO({ data: params }),
        DocumentCreateDTO,
        DocumentItemRO
      )) ?? { data: {} }

      return response
    },
  },
})
